// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";
// import { getMessaging, onMessage, getToken } from "firebase/messaging";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyC_9G-XAlW6LUcby8RXTx9BWh6h-66MyN8",
  authDomain: "affiliate-indonesia.firebaseapp.com",
  projectId: "affiliate-indonesia",
  storageBucket: "affiliate-indonesia.appspot.com",
  messagingSenderId: "405747444528",
  appId: "1:405747444528:web:5a05565f493fa1153bb6f5",
  measurementId: "G-EB2MRH8Z7J",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const db = getFirestore(app);
const storage = getStorage(app);
// const configMessage = getMessaging(app);

export { auth, db, app, storage };
